import type { AlgoliaClient } from "@lib/wrappers/algolia/types";
import { algoliaSearch, algoliaBrowse, getIndexName } from "@lib/wrappers/algolia/algoliaWrapper";
import { useMemo } from "react";

export const useAlgoliaClient = (
    locale: string,
    mode: "products" | "stores" = "products"
): {
    searchClient: AlgoliaClient;
    browseClient: AlgoliaClient;
    indexName: string;
} => {
    const {
        algoliaBrowse: browseClient,
        algoliaSearch: searchClient,
        indexName,
    } = useMemo(
        () => ({
            algoliaBrowse: algoliaBrowse(locale),
            algoliaSearch: algoliaSearch(locale),
            indexName: getIndexName(locale, mode),
        }),
        [locale, mode]
    );

    return { searchClient, browseClient, indexName };
};
